/*
 *
 * Artifactory is a binaries repository manager.
 * Copyright (C) 2018 JFrog Ltd.
 *
 * Artifactory is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 * Artifactory is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Artifactory.  If not, see <http://www.gnu.org/licenses/>.
 *
 */
export default {
    "file": {
        "icon": "icon icon-general"
    },
    "default": {
        "icon": "icon icon-general"
    },
    "virtualRemoteFile": {
        "icon": "icon icon-general"
    },
    "go_up": {
        "icon": "icon icon-folder go-up"
    },
    "localRepository": {
        "icon": "icon icon-jfui-local-repository"
    },
    "buildInfoRepository": {
        "icon": "icon icon-sidebar-builds"
    },
    "supportBundles": {
        "icon": "icon icon-support"
    },
    "cachedRepository": {
        "icon": "icon icon-jfui-virtual-repository"
    },
    "virtualRepository": {
        "icon": "icon icon-jfui-virtual-repository"
    },
    "distributionRepository": {
        "icon": "icon icon-distribution-repo"
    },
    "remoteRepository": {
        "icon": "icon icon-jfui-remote-repository"
    },
    "stash": {
        "icon": "icon icon-search"
    },
    "trashcan": {
        "icon": "icon icon-trash"
    },
    "folder": {
        "icon": "icon icon-jfui-folder-close"
    },
    "virtualRemoteFolder": {
        "icon": "icon icon-jfui-folder-close"
    },
    "compactedFolder": {
        "icon": "icon icon-jfui-folder-close"
    },
    "application/x-maven-pom+xml": {
        "icon": "icon icon-pom"
    },
    "application/xml": {
        "icon": "icon icon-xml"
    },
    "application/pdf": {
        "icon": "icon icon-pdf"
    },
    "text/html": {
        "icon": "icon icon-html"
    },
    "text/plain": {
        "icon": "icon icon-txt"
    },
    "text/css": {
        "icon": "icon icon-css"
    },
    "application/json": {
        "icon": "icon icon-json"
    },
    "application/x-debian-package": {
        "icon": "icon icon-deb"
    },
    "application/javascript": {
        "icon": "icon icon-js"
    },
    "application/x-rubygems": {
        "icon": "icon icon-gems"
    },
    "text/x-java-source": {
        "icon": "icon icon-java"
    },
    "x-groovy-source": {
        "icon": "icon icon-groovy"
    },
    "text/x-c": {
        "icon": "icon icon-c"
    },
    "text/x-csharp": {
        "icon": "icon icon-c-2"
    },
    "application/zip": {
        "icon": "icon icon-zip"
    },
    "application/x-gzip": {
        "icon": "icon icon-gz"
    },
    "application/x-gtar": {
        "icon": "icon icon-gz"
    },
    "application/x-tar": {
        "icon": "icon icon-tar"
    },
    "application/x-nupkg": {
        "icon": "icon icon-nuget"
    },
    "application/x-rpm": {
        "icon": "icon icon-rpm"
    },
    "text/x-scala-source": {
        "icon": "icon icon-scala"
    },
    "application/java-archive": {
        "icon": "icon icon-jar"
    },
    "application/octet-stream": {
        "icon": "icon icon-general"
    },
    "docker": {
        "icon": "icon icon-docker"
    },
    "bower": {
        "icon": "icon icon-bower"
    },
    "npm": {
        "icon": "icon icon-npm"
    },
    "cocoapods": {
        "icon": "icon icon-cocoapods"
    },
    "gitlfs": {
        "icon": "icon icon-git-lfs"
    },
    "opkg": {
        "icon": "icon icon-opkg"
    },
    "composer": {
        "icon": "icon icon-composer"
    },
    "conan": {
        "icon": "icon icon-conan"
    },
    "puppet": {
        "icon": "icon icon-puppet"
    },
    "pypi": {
        "icon": "icon icon-pypi"
    },
    "gradle": {
        "icon": "icon icon-gradle"
    },
    "vagrant":{
        "icon": "icon icon-vagrant"
    },
    "helm":{
        "icon": "icon icon-helm"
    },
    "chef":{
        "icon": "icon icon-chef"
    },
    "go":{
        "icon": "icon icon-golang"
    },
    "cran":{
        "icon": "icon icon-cran"
    },
    "conda": {
        "icon": "icon icon-conda"
    }
}



// WEBPACK FOOTER //
// ./states/artifacts/constants/artifact_browser_icons.constant.js